/* Cathaya Locale Bridge v7 - hijack the REAL GTranslate select to handle English revert */
(function () {
  "use strict";

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function setCookie(n, v, days) {
    var d = new Date(); d.setTime(d.getTime() + (days || 365) * 86400000);
    document.cookie = n + "=" + v + ";expires=" + d.toUTCString() + ";path=/";
  }
  function clearGooGTransCookie() {
    var paths = ["/"];
    var domains = ["", location.hostname, "." + location.hostname];
    var parts = location.hostname.split(".");
    while (parts.length > 1) { domains.push("." + parts.join(".")); parts.shift(); }
    domains.forEach(function (dom) {
      paths.forEach(function (p) {
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=" + p + (dom ? "; domain=" + dom : "");
      });
    });
  }

  function revertToEnglish() {
    console.info("[cathaya-locale] revertToEnglish: clearing cookies + reloading");
    clearGooGTransCookie();
    // Strip ?lang param if present
    var url = new URL(location.href);
    url.searchParams.delete("lang");
    url.searchParams.delete("_lang");
    location.href = url.pathname + url.search + url.hash;
  }

  // ---------- HIJACK GTranslate's real select ----------
  // GTranslate puts onchange="doGTranslate(this.value)" attribute on its select.
  // When user picks English (value ends in "|en"), doGTranslate doesn't reliably
  // restore the original language. We intercept BEFORE doGTranslate fires.
  var hijackedSelects = new WeakSet();
  function hijackGTranslateSelects() {
    $$("select.gt_selector, .gtranslate_wrapper select, #gtranslate_selector").forEach(function (sel) {
      if (hijackedSelects.has(sel)) return;
      hijackedSelects.add(sel);
      // Capture-phase listener — fires BEFORE the inline onchange attribute
      sel.addEventListener("change", function (e) {
        var v = sel.value || "";
        // v looks like "en|fr" or "en|en"
        var target = v.split("|")[1];
        console.info("[cathaya-locale] GT select changed to", v, "target=", target);
        if (target === "en" || target === sel.dataset.gtBaseLang || target === "") {
          // English / base language — stop GTranslate's handler, do our reset
          e.stopImmediatePropagation();
          e.preventDefault();
          revertToEnglish();
        }
      }, true);
      console.info("[cathaya-locale] hijacked GT select, options:", sel.options.length);
    });
  }

  // ---------- Bucks ----------
  function detectBucksCurrencies() {
    var curs = [];
    var sel = $("select.buckscc-original-select") || $(".buckscc-original-select") || $(".bucks-currency-converter select");
    if (sel && sel.tagName === "SELECT") {
      $$("option", sel).forEach(function (o) {
        var v = (o.value || "").trim(), lb = (o.textContent || "").trim();
        if (v && lb) curs.push({ code: v, label: lb });
      });
      if (curs.length) return curs;
    }
    var liItems = $$(".buckscc-select-options li, ul[class*='select-options'] li, [class*='hxoSelectTheme'] li");
    liItems.forEach(function (li) {
      var v = (li.getAttribute("data-value") || li.dataset.value || li.textContent || "").trim().substring(0, 3).toUpperCase();
      var lb = (li.textContent || "").trim();
      if (v && lb && /^[A-Z]{3}/.test(v)) curs.push({ code: v, label: lb });
    });
    if (curs.length) return curs;
    return [
      { code: "EUR", label: "EUR €" },
      { code: "USD", label: "USD $" },
      { code: "GBP", label: "GBP £" },
      { code: "AED", label: "AED د.إ" },
      { code: "CAD", label: "CAD $" },
      { code: "AUD", label: "AUD $" },
      { code: "JPY", label: "JPY ¥" }
    ];
  }

  function switchCurrency(code) {
    var realSel = $("select.buckscc-original-select") || $(".buckscc-original-select") || $(".bucks-currency-converter select");
    if (realSel && realSel.tagName === "SELECT") {
      realSel.value = code;
      realSel.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    var liToClick = $$(".buckscc-select-options li, ul[class*='select-options'] li, [class*='hxoSelectTheme'] li").find(function (li) {
      return (li.textContent || "").trim().toUpperCase().indexOf(code) >= 0;
    });
    if (liToClick) { liToClick.click(); return; }
    setCookie("bucks_currency", code); setCookie("cart_currency", code); setCookie("currency", code);
    location.reload();
  }

  function buildSelect(mountId, items, currentValue, label, onChange) {
    var slot = document.getElementById(mountId);
    if (!slot || !items || !items.length) return false;
    if (slot.querySelector(".gt_selector, [class*='gt_container'], [class*='buckscc'], [class*='hxoSelectTheme']")) {
      slot.dataset.cathayaMounted = "true"; slot.classList.add("is-mounted"); return false;
    }
    slot.innerHTML = "";
    var sel = document.createElement("select");
    sel.setAttribute("aria-label", label);
    sel.className = "c-locale-select notranslate cathaya-fallback";
    items.forEach(function (it) {
      var o = document.createElement("option");
      o.value = it.code; o.textContent = it.label;
      if (it.code === currentValue) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener("change", function () { onChange(sel.value); });
    slot.appendChild(sel);
    slot.classList.add("is-mounted");
    slot.dataset.cathayaMounted = "true";
    return true;
  }

  function detectCurrentLang() {
    var m = document.cookie.match(/googtrans=\/[^\/]+\/([a-z-]+)/i);
    if (m) return "en|" + m[1];
    return "en|" + (document.documentElement.lang || "en").split("-")[0];
  }
  function detectCurrentCurrency() {
    var m = document.cookie.match(/(?:bucks_currency|cart_currency|currency)=([A-Z]{3})/);
    if (m) return m[1];
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return "EUR";
  }

  function sweepDuplicates() {
    ["cathaya-gt-mount", "cathaya-bucks-mount"].forEach(function (id) {
      var slot = document.getElementById(id);
      if (!slot) return;
      var real = slot.querySelector(id === "cathaya-gt-mount"
        ? ".gt_selector, [class*='gt_container'], [class*='gt_switcher_wrapper']"
        : "[class*='buckscc'], [class*='hxoSelectTheme']");
      var fb = slot.querySelector("select.cathaya-fallback");
      if (real && fb) fb.remove();
    });
  }

  function nukeFloaters() {
    var patterns = [
      "[class^='gt_container']", "[class*=' gt_container']", ".gt_container",
      ".gt_switcher_wrapper", "[class*='gt_switcher_wrapper']",
      ".gt_float_switcher", ".gtranslate-floater", ".gtranslate_wrapper",
      "#gtranslate_wrapper", "#gtranslate_bubble", "#gt-translate-trigger",
      "#google_translate_element", ".goog-te-gadget", ".goog-te-banner-frame", ".goog-te-menu-frame", ".skiptranslate",
      ".buckscc-select-styled", "[class*='hxoSelectTheme']",
      ".bucks-currency-converter", "[data-bucks-widget]",
      "[class*='_FloatingControlsWrapper']", "[class*='_floatingControlsWrapper']"
    ];
    patterns.forEach(function (sel) {
      $$(sel).forEach(function (el) {
        if (el.closest("#cathaya-gt-mount") || el.closest("#cathaya-bucks-mount")) return;
        el.style.cssText = "position:fixed!important;top:-9999px!important;left:-9999px!important;width:1px!important;height:1px!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;z-index:-1!important;transform:scale(0)!important;display:none!important;";
      });
    });
  }

  var FALLBACK_LANGS = [
    { code: "en|en", label: "English" },
    { code: "en|es", label: "Español" },
    { code: "en|fr", label: "Français" },
    { code: "en|de", label: "Deutsch" },
    { code: "en|zh-CN", label: "中文" }
  ];

  function tryBuild() {
    var gtSlot = document.getElementById("cathaya-gt-mount");
    if (gtSlot && !gtSlot.dataset.cathayaMounted) {
      if (gtSlot.querySelector(".gt_selector, [class*='gt_container']")) {
        gtSlot.dataset.cathayaMounted = "true"; gtSlot.classList.add("is-mounted");
      }
    }
    var bucksSlot = document.getElementById("cathaya-bucks-mount");
    if (bucksSlot && !bucksSlot.dataset.cathayaMounted) {
      if (bucksSlot.querySelector("[class*='buckscc'], [class*='hxoSelectTheme']")) {
        bucksSlot.dataset.cathayaMounted = "true"; bucksSlot.classList.add("is-mounted");
      } else if (document.querySelector("[class*='buckscc'], [class*='hxoSelectTheme']") && !bucksSlot.querySelector("select")) {
        buildSelect("cathaya-bucks-mount", detectBucksCurrencies(), detectCurrentCurrency(), "Currency", switchCurrency);
      }
    }
    sweepDuplicates();
    nukeFloaters();
    hijackGTranslateSelects();  // <-- crucial new step every tick
  }

  function buildFinalFallbacks() {
    var gtSlot = document.getElementById("cathaya-gt-mount");
    if (gtSlot && !gtSlot.querySelector("select, .gt_selector, [class*='gt_container']")) {
      buildSelect("cathaya-gt-mount", FALLBACK_LANGS, detectCurrentLang(), "Language", function (code) {
        var t = code.split("|")[1];
        if (t === "en") return revertToEnglish();
        if (typeof window.doGTranslate === "function") { try { window.doGTranslate(code); return; } catch (e) {} }
        setCookie("googtrans", "/auto/" + t); location.reload();
      });
    }
    var bucksSlot = document.getElementById("cathaya-bucks-mount");
    if (bucksSlot && !bucksSlot.querySelector("select, [class*='buckscc'], [class*='hxoSelectTheme']")) {
      buildSelect("cathaya-bucks-mount", detectBucksCurrencies(), detectCurrentCurrency(), "Currency", switchCurrency);
    }
  }

  function init() {
    tryBuild();
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      tryBuild();
      if (attempts === 8) buildFinalFallbacks();
      if (attempts >= 20) clearInterval(iv);
    }, 500);
    var nukeIv = setInterval(function () { nukeFloaters(); hijackGTranslateSelects(); }, 1000);
    setTimeout(function () { clearInterval(nukeIv); }, 30000);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", function () {
    ["cathaya-gt-mount", "cathaya-bucks-mount"].forEach(function (id) {
      var s = document.getElementById(id);
      if (s) { s.dataset.cathayaMounted = ""; s.classList.remove("is-mounted"); s.innerHTML = ""; }
    });
    tryBuild();
  });
})();
